module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.ttf?c8e090db312b0bea2aa200ced9273f1c";